import BaseModel from './BaseModel';

class HeadUser extends BaseModel {
  constructor(data = {}, api_data = false) {
    super(data);
    if(api_data) {
      this.setApiData(data);
    } else {
      this.updateData(data)
    }
  }

  setApiData = (data) => {
    this.id = data.id;
    this.name = data.name;
    this.email = data.email;
    this.mobile_number = data.mobile_number;
    this.employee_id = data.employee_id;
    this.profiles = data.profiles;
    if(data.branch) {
      this.branch_id = data.branch.id || null
      this.branch_name = data.branch.name || null
    }
    if(data.users_types){
      this.users_types = data.users_types || [];
      this.head_user_type = data.users_types[0].role_name;
    }

    if(data.cluster_user_config_attributes) {
      this.cluster_user_config_attributes = data.cluster_user_config_attributes || [];
    }

    if(data.clusters) {
      this.clusters = data.clusters || [];
      this.cluster_ids = [data.clusters[0].id] || [];
      this.branch_for_cluster = data.clusters[0].branch_name || "";
    }

    if(data.circles) {
      this.circles = data.circles || [];
      this.branch_ids = [data.circles[0].id] || [];
    }

    if(data.zones) {
      this.zones = data.zones || [];
      this.zone_ids = [data.zones[0].id] || [];
    }

    if(data.circle_user_configs_attributes) {
      this.circle_user_configs_attributes = data.circle_user_configs_attributes || [];
    }

    if(data.cluster_user_config_attributes) {
      this.cluster_ids = data.cluster_user_config_attributes.map((configs) => {
        return configs?.cluster_ids;
      }) || []
    }

    if(data.circle_user_configs_attributes) {
      this.branch_ids = data.circle_user_configs_attributes.map((configs) => {
        return configs?.circle_id;
      }) || []
    }
  }

  setDetailsData = () => {
    return {
      id: this.id,
      name: this.name,
      email: this.email,
      mobile_number: this.mobile_number,
      employee_id: this.employee_id,
      profiles: this.profiles,
      circle: `${this.branch_id} - ${this.branch_name}`,
      user_types: this.users_types
    }
  }

  createClusterUserConfig = (cluster_ids) => {
    if(cluster_ids == undefined) return []
    return this.cluster_user_configs_attributes = cluster_ids.map((cluster_id) => {
      return {
        cluster_id: cluster_id,
        user_id: this.cluster_user_configs_attributes[0]?.user_id || "",
        company_id: 2,
        is_valid: true
      }
    })
  };

  createZonalUserConfig = (zone_ids) => {
    if(zone_ids === undefined) return []
    return this.zone_user_mappings_attributes = zone_ids.map((zone_id) => {
      return {
        zone_id: zone_id,
        company_id: 2,
        is_valid: true
      }
    })
  }

  createCircleUserConfig = (branch_ids) => {
    if(branch_ids == undefined) return []
    return this.circle_user_configs_attributes = branch_ids.map((branch_id) => {
      return {
        branch_id: branch_id,
        user_id: this.circle_user_configs_attributes[0]?.user_id || "",
        company_id: 2,
        is_valid: true
      }
    })
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.email = data.email || "";
    this.mobile_number = data.mobile_number || "";
    this.employee_id = data.employee_id || "";
    this.profiles = data.profiles || [];
    this.users_types = data.users_types || [];
    this.head_user_type = data.head_user_type || "";
    this.branch_for_cluster = data.branch_for_cluster || "";
    this.clusters = data.clusters || [];
    this.circles = data.circles || [];
    this.zones = data.zones || [];
    if(this.head_user_type === 'FSO'){
        this.fso_service_type = data.fso_service_type || [];
        if(this.fso_service_type && this.fso_service_type.includes('baas')){
          this.fso_vehicle_type = data.fso_vehicle_type || [];
        }
    } else if(this.head_user_type === 'cluster_head'){
      if(data.clusters.length !== 0) {
        this.cluster_ids = [data.clusters[0].id] || [];
        this.branch_for_cluster = data.clusters[0].branch_name || "";
      }
      this.cluster_ids = data.cluster_ids || [];
      this.cluster_user_configs_attributes = data.cluster_user_configs_attributes || [];
    } else if(this.head_user_type === "circle_head"){
      this.branch_ids = data.branch_ids || [];
      if(data.circles.length !== 0) {
        this.branch_ids = [data.circles[0].id] || [];
      }
      this.circle_user_configs_attributes = data.circle_user_configs_attributes || [];
    } else if(this.head_user_type === "zonal_head"){
      this.zone_ids = data.zone_ids || [];
      this.zone_user_mappings_attributes = data.zone_user_mappings_attributes || [];
    }
    this.user_type_id = data.user_type_id || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      user: {
        name: this.name,
        email: this.email,
        mobile_number: this.mobile_number,
        employee_id: this.employee_id,
        user_roles_attributes: [{users_type_id: this.user_type_id}],
        profiles: this.profiles,
        circle_user_mappings_attributes: this.createCircleUserConfig(this.branch_ids),
        cluster_user_mappings_attributes: this.createClusterUserConfig(this.cluster_ids),
        zone_user_mappings_attributes: this.createZonalUserConfig(this.zone_ids)
      }
    }
  }

  toUpdateApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      user: {
        name: this.name,
        email: this.email,
        mobile_number: this.mobile_number,
        employee_id: this.employee_id
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field].trim() === "") {
          this.errors.name = "This field is required and cannot be empty.";
        }
        else if(this[field].search(/^[a-zA-Z\s'-]+$/) === -1){
          this.errors.name = "Please enter a name using only letters.";
        } else {
          delete this.errors.name;
        }
      },
      email: () => {
        if(this[field].trim() === "") {
          this.errors.email = "This field is required and cannot be empty.";
        }
        else if(this[field].search(/^.+\@.{3,}\..{2,}$/) === -1) {
          this.errors.email ="Invalid email format."
        } else{
          delete this.errors.email;
        }
      },
      mobile_number: () => {
        if(this[field].trim() === "") {
          this.errors.mobile_number = "This field is required and cannot be empty.";
        }
        else if(this[field].search(/^\d{10}$/) === -1) {
          this.errors.mobile_number = "Invalid mobile number format."
        } else {
          delete this.errors.mobile_number;
        }
      },
      employee_id: () => {
        if (this.employee_id.trim() !== "") {
          if(this[field].search(/^[0-9]+$/) === -1){
            this.errors.employee_id = "Employee ID should contains only numbers.";
          } else{
            delete this.errors.employee_id;
          }
        } else{
          delete this.errors.employee_id;
        }
      },
      head_user_type: () => {
        if (this[field] === "") {
          this.errors.head_user_type = "Please select head user type.";
        } else {
          delete this.errors.head_user_type;
        }  
      },
      profiles: () => {
        if (this.head_user_type === "area_head" && this.profiles.length === 0) {
          this.errors.profiles = "Please select profile type.";
        } else {
          delete this.errors.profiles;
        }
      },
      cluster_ids: () => {
        if (this.head_user_type === "cluster_head" && this.cluster_ids.length === 0) {
          this.errors.cluster_ids = "Please select cluster.";
        } else {
          delete this.errors.cluster_ids;
        }
      },
      branch_ids: () => {
        if (this.head_user_type === "circle_head" && this.branch_ids.length === 0) {
          this.errors.branch_ids = "Please select branch.";
        } else {
          delete this.errors.branch_ids;
        }
      },
      zone_ids: () => {
        if (this.head_user_type === "zonal_head" && this.zone_ids.length === 0) {
          this.errors.zone_ids = "Please select zone.";
        } else {
          delete this.errors.zone_ids;
        }
      }
      // fso_service_type: () => {
      //   if (this.head_user_type === "FSO" && this.fso_service_type.length === 0) {
      //     this.errors.fso_service_type = "Please select service type.";
      //   } else {
      //     delete this.errors.fso_service_type;
      //   }
      // },
      // fso_vehicle_type: () => {
      //   if ((this.head_user_type === "FSO" && this.fso_service_type.includes('baas')) && this.fso_vehicle_type.length === 0) {
      //     this.errors.fso_vehicle_type = "Please select vehicle type.";
      //   } else {
      //     delete this.errors.fso_vehicle_type;
      //   }
      // }

    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default HeadUser;
